import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from '../../../components/common/icon/Icon';
import { useLayout } from '../../../hooks/screen/useLayout';

export const ErrorPage = () => {
  const navigate = useNavigate();

  useLayout({
    fixedHeader: <></>,
    fixedFooter: <></>,
    fixedFooterHeight: 0,
    fixedHeaderHeight: 0,
  });

  const goToHome = () => {
    window.location.href = `${window.location.origin}/home`;
  };

  useEffect(() => {
    const goToHomeTimeout = setTimeout(() => {
      goToHome();
    }, 3000);

    return () => clearTimeout(goToHomeTimeout);
  }, []);

  return (
    <Container>
      <Icon name={'EmptyBox2'} width={160} height={160} />
      <TextSection>
        <Title>{'앗! 죄송합니다'}</Title>
        <Content>{'예기치 못한 에러가 발생했어요.\n3초 후 홈으로 이동합니다'}</Content>
      </TextSection>
      <GotoHomeButton onClick={goToHome}>
        <ButtonText>{'홈으로'}</ButtonText>
      </GotoHomeButton>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 32px;
`;

const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 4px;
`;

const Title = styled.h2`
  color: var(--light-scheme-monochrome-black, #232429);
  /* System/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 15.3px */
`;

const Content = styled.pre`
  color: var(--light-scheme-monochrome-offblack, #505363);
  text-align: center;
  /* Body/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;

const GotoHomeButton = styled.button`
  display: flex;
  width: 167px;
  max-height: 40px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: var(--radius-medium, 8px);
  background: var(--light-scheme-color-primary-blue, #445eff);
`;

const ButtonText = styled.span`
  color: var(--light-scheme-monochrome-white, #fff);
  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
